import React from "react";
import Skeleton from "./Skeleton";
import styles from "../../style/projects.module.css";
import skeletonStyles from "../../style/skeleton.module.css";

const GRID_VARIANT_CLASSES = {
  showcase: styles.projectsGridShowcase,
};

const ProjectCardSkeleton = () => (
  <div className={skeletonStyles.skeletonProjectCard}>
    <Skeleton className={skeletonStyles.skeletonImage} />
    <div className={skeletonStyles.skeletonProjectCardBody}>
      <Skeleton className={skeletonStyles.skeletonProjectCardTitle} />
      <Skeleton className={skeletonStyles.skeletonProjectCardSummary} />
      <Skeleton
        className={`${skeletonStyles.skeletonProjectCardSummary} ${skeletonStyles.skeletonProjectCardSummaryShort}`}
      />
      <div className={skeletonStyles.skeletonProjectCardTags}>
        <Skeleton
          className={`${skeletonStyles.skeletonTag} ${skeletonStyles.skeletonPill}`}
        />
        <Skeleton
          className={`${skeletonStyles.skeletonTag} ${skeletonStyles.skeletonPill}`}
        />
        <Skeleton
          className={`${skeletonStyles.skeletonTag} ${skeletonStyles.skeletonPill}`}
        />
      </div>
    </div>
  </div>
);

const ProjectCardsSkeleton = ({
  count = 3,
  variant = "",
  gridClassName = "",
}) => (
  <div
    className={`${styles.projectsGrid} skeleton-page${
      variant && GRID_VARIANT_CLASSES[variant] ? ` ${GRID_VARIANT_CLASSES[variant]}` : ""
    }${gridClassName ? ` ${gridClassName}` : ""}`}
    aria-busy="true"
    aria-live="polite"
    aria-label="Loading projects"
  >
    {Array.from({ length: count }, (_, index) => (
      <ProjectCardSkeleton key={index} />
    ))}
  </div>
);

export default ProjectCardsSkeleton;
